import { ItiBaseDto } from '@/iti-core-vue';
import { Rol } from './rol';
import { User } from './user';


export class CollaborativeAreaMember extends ItiBaseDto {
    public roleId !: number;
    // public role !: Rol;
    public roleInAmbit !: Rol;
    public userId !: number;
    public user !: User;
    public ambitId !: number;    
}